/**
 * Fine-tunes h2 font sizes on legal pages if CSS viewport sizing still causes word breaks
 * h1 and h2 base sizing is handled by CSS with viewport units
 */
(function() {
  'use strict';

  function hasTextBreak(element) {
    // Store original state
    const originalHTML = element.innerHTML;
    const originalFontSize = element.style.fontSize;
    
    // Reset to check natural state
    element.style.fontSize = '';
    
    // Get the element's dimensions
    const scrollHeight = element.scrollHeight;
    const clientHeight = element.clientHeight;
    
    // Check if scrollHeight is significantly greater than clientHeight
    // This indicates text is wrapping/breaking
    const heightDifference = scrollHeight - clientHeight;
    
    // Check if any text spans multiple lines by measuring line height
    const computedStyle = window.getComputedStyle(element);
    const lineHeight = parseFloat(computedStyle.lineHeight) || parseFloat(computedStyle.fontSize) * 1.2;
    
    // If scrollHeight is more than 1.5x the line height, text is likely breaking
    const hasBreak = scrollHeight > lineHeight * 1.5 || heightDifference > 5;
    
    // Check by wrapping words and measuring positions
    const text = element.textContent.trim();
    if (text && !hasBreak) {
      const words = text.split(/\s+/);
      if (words.length > 0) {
        // Wrap each word in a span to measure its position
        const wordSpans = words.map(function(word) {
          const span = document.createElement('span');
          span.textContent = word;
          span.style.whiteSpace = 'nowrap';
          return span;
        });
        
        // Clear element and add word spans with spaces
        element.innerHTML = '';
        wordSpans.forEach(function(span, index) {
          element.appendChild(span);
          if (index < wordSpans.length - 1) {
            element.appendChild(document.createTextNode(' '));
          }
        });
        
        // Force a reflow
        void element.offsetHeight;
        
        // Get the first line's bottom position
        const firstSpan = wordSpans[0];
        if (firstSpan) {
          const firstLineBottom = firstSpan.offsetTop + firstSpan.offsetHeight;
          
          // Check if any word span is below the first line (indicating a break)
          for (let i = 0; i < wordSpans.length; i++) {
            const span = wordSpans[i];
            const spanTop = span.offsetTop;
            // If a span starts below the first line, text has broken
            if (spanTop > firstLineBottom + 2) { // 2px tolerance
              element.innerHTML = originalHTML;
              element.style.fontSize = originalFontSize;
              return true;
            }
          }
        }
      }
    }
    
    // Restore original HTML
    element.innerHTML = originalHTML;
    element.style.fontSize = originalFontSize;
    
    return hasBreak;
  }

  function adjustPolicyTitleSizes() {
    // Only run on mobile devices (max-width: 749px)
    if (window.innerWidth > 749) return;
    
    // Find all h2 elements - h1 is fully handled by CSS
    const h2s = Array.from(document.querySelectorAll(
      '.shopify-policy__title h2, .rte h2, .shopify-policy__container h2'
    )).filter(function(el) { return el.tagName === 'H2'; });
    
    if (h2s.length === 0) return;
    
    // Find minimum size needed if any h2 breaks
    function findMinSizeForGroup(headings) {
      let minSize = null;
      
      headings.forEach(function(heading) {
        if (hasTextBreak(heading)) {
          const currentSize = parseFloat(window.getComputedStyle(heading).fontSize);
          let testSize = currentSize * 0.95;
          const absoluteMin = currentSize * 0.75;
          
          let attempts = 0;
          while (testSize >= absoluteMin && attempts < 20) {
            heading.style.fontSize = testSize + 'px';
            void heading.offsetHeight;
            
            if (!hasTextBreak(heading)) {
              if (minSize === null || testSize < minSize) {
                minSize = testSize;
              }
              break;
            }
            
            testSize = testSize * 0.97;
            attempts++;
          }
          
          if (hasTextBreak(heading) && (minSize === null || absoluteMin < minSize)) {
            minSize = absoluteMin;
          }
        }
      });
      
      return minSize;
    }
    
    // Apply consistent size to all h2s if any break
    const h2MinSize = findMinSizeForGroup(h2s);
    if (h2MinSize !== null) {
      h2s.forEach(function(h2) {
        h2.style.fontSize = h2MinSize + 'px';
      });
    }
  }

  function runAdjustment() {
    requestAnimationFrame(adjustPolicyTitleSizes);
  }

  // Run when body is ready
  function init() {
    if (document.body) {
      runAdjustment();
    } else {
      const checkBody = setInterval(function() {
        if (document.body) {
          clearInterval(checkBody);
          runAdjustment();
        }
      }, 10);
    }
  }

  // Initialize
  init();

  // Watch for dynamically added content
  if (typeof MutationObserver !== 'undefined') {
    const observer = new MutationObserver(function(mutations) {
      for (let i = 0; i < mutations.length; i++) {
        const nodes = mutations[i].addedNodes;
        for (let j = 0; j < nodes.length; j++) {
          const node = nodes[j];
          if (node && node.nodeType === 1) {
            const element = node;
            if ((element.matches && element.matches('.shopify-policy__container, .shopify-policy__title, .rte')) ||
                (element.querySelector && element.querySelector('.shopify-policy__container, .shopify-policy__title, .rte'))) {
              runAdjustment();
              return;
            }
          }
        }
      }
    });

    if (document.body) {
      observer.observe(document.body, { childList: true, subtree: true });
    } else {
      const waitForBody = setInterval(function() {
        if (document.body) {
          clearInterval(waitForBody);
          observer.observe(document.body, { childList: true, subtree: true });
        }
      }, 10);
    }
  }

  // Backup: run on DOMContentLoaded
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', runAdjustment);
  }

  // Handle window resize
  let resizeTimeout;
  window.addEventListener('resize', function() {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(runAdjustment, 150);
  });
})();

